import Model, { attr } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type NumberTransform from 'teacher-ui-client/transforms/number'

export default class SchoolStatistics extends Model {
  @attr<NumberTransform>('number') declare totalStudentCount: number;

  [Type] = 'school-statistic' as const
}
